"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ListContainer = void 0;

var react_1 = __importDefault(require("react"));

var list_item_1 = require("./list-item");

var ListContainer = function ListContainer(_a) {
  var list = _a.list,
      theme = _a.theme,
      language = _a.language;
  return react_1["default"].createElement("ul", {
    className: "w-full overflow-hidden"
  }, list.map(function (item, index) {
    return react_1["default"].createElement(list_item_1.ListItem, {
      item: item,
      key: index,
      theme: theme,
      language: language
    });
  }));
};

exports.ListContainer = ListContainer;